var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Controller } from "@hotwired/stimulus";
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import axios from "axios";
import { ATTRIBUTION_REQUEST_FIELDS, attributionRequestParams, currentSearch, resolveHostAttribution, safeLocalStorage, } from "../../../../resources/ts/bookingWidget/attribution";
export default class extends Controller {
    connect() {
        this.element.addEventListener("submit", this.submitForm.bind(this));
        this.initTelephoneFormatting();
        this.fillAttributionInputs();
    }
    /**
     * Ad-click attribution (3 Oct 2026): same capture rules as the booking widget's shim (URL first,
     * else the 90-day first-touch record in localStorage `bb_attribution`) written into the form's
     * hidden gclid/utm_* inputs, which SiteEnquiryController::store stamps on the enquiry.
     */
    fillAttributionInputs() {
        try {
            const params = attributionRequestParams(resolveHostAttribution(currentSearch(), safeLocalStorage(), Date.now()));
            for (const field of ATTRIBUTION_REQUEST_FIELDS) {
                const input = this.element.querySelector(`input[type="hidden"][name="${field}"]`);
                if (input && params[field]) {
                    input.value = params[field];
                }
            }
        }
        catch (e) {
            // Attribution is best-effort and must never block an enquiry.
        }
    }
    submitForm(event) {
        event.preventDefault();
        const phone = document.querySelector("#phone");
        if (this.validate(true)) {
            this.element.submit();
        }
    }
    validate(isFailureLogged) {
        let valid = true;
        const phoneInput = document.querySelector("#phoneInput");
        if (!this.iti.isValidNumber()) {
            valid = false;
            phoneInput.setCustomValidity('Invalid phone number');
            if (isFailureLogged) {
                axios.post("/log/validation", { iti: this.iti.getNumber(), form: phoneInput.value });
            }
        }
        else {
            phoneInput.setCustomValidity('');
        }
        phoneInput.reportValidity();
        return valid;
    }
    initTelephoneFormatting() {
        const input = document.querySelector("#phoneInput");
        if (input != null) {
            this.iti = intlTelInput(input, {
                preferredCountries: ["us", "au"],
                initialCountry: "auto",
                geoIpLookup: function (countryCode) {
                    axios.get("https://ipinfo.io/json?token=d78ddc2b0498c8").then(response => {
                        var countryCodeValue = (response && response.data && response.data.country) ? response.data.country : "us";
                        countryCode(countryCodeValue);
                    });
                },
                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.18/js/utils.min.js",
            });
            input.addEventListener("blur", this.phoneBlur.bind(this));
            input.addEventListener("keyup", this.phoneKeyPress.bind(this));
        }
    }
    phoneBlur() {
        const phoneInput = document.querySelector("#phoneInput");
        const phoneHidden = document.querySelector("#phone");
        const phoneNumber = this.iti.getNumber();
        if (phoneHidden != null) {
            phoneHidden.value = phoneNumber;
        }
        if (this.iti.isValidNumber()) {
            const phoneFormatted = intlTelInputUtils.formatNumber(phoneNumber, '', intlTelInputUtils.numberFormat.NATIONAL);
            if (phoneInput != null) {
                phoneInput.value = phoneFormatted;
            }
        }
    }
    phoneKeyPress() {
        this.validate(false);
    }
    refreshEstimatedGuestsField(event) {
        this._submitForm(event, true).then((documentFragment) => {
            this.updateEstimatedGuestsField(documentFragment);
            this.updateTimeSlotChoices(documentFragment);
            this.updatePricingData(documentFragment);
            this.updateUserDetails(documentFragment);
            this.updateFormActions(documentFragment);
            this.updateDurationChoices(documentFragment);
            this.initTelephoneFormatting();
        });
    }
    refreshTimeSlotChoices(event) {
        this._submitForm(event, true).then((documentFragment) => {
            this.updateEstimatedGuestsField(documentFragment);
            this.updateTimeSlotChoices(documentFragment);
            this.updatePricingData(documentFragment);
            this.updateUserDetails(documentFragment);
            this.updateFormActions(documentFragment);
            this.updateDurationChoices(documentFragment);
            this.initTelephoneFormatting();
        });
    }
    refreshPricing(event) {
        this._submitForm(event, true).then((documentFragment) => {
            this.updateEstimatedGuestsField(documentFragment);
            this.updatePricingData(documentFragment);
            this.updateUserDetails(documentFragment);
            this.updateFormActions(documentFragment);
            this.updateDurationChoices(documentFragment);
            this.initTelephoneFormatting();
        });
    }
    updateEstimatedGuestsField(documentFragment) {
        var _a;
        let newEstimatedGuestsField = documentFragment.getElementById("estimatedGuestsField");
        (_a = this.element.querySelector("#estimatedGuestsField")) === null || _a === void 0 ? void 0 : _a.replaceWith(newEstimatedGuestsField);
    }
    updatePricingData(documentFragment) {
        var _a;
        let newPricingData = documentFragment.getElementById("pricingData");
        (_a = this.element.querySelector("#pricingData")) === null || _a === void 0 ? void 0 : _a.replaceWith(newPricingData);
    }
    updateTimeSlotChoices(documentFragment) {
        var _a;
        let newTimeSlotFieldset = documentFragment.getElementById("timeSlotFieldset");
        (_a = this.element.querySelector("#timeSlotFieldset")) === null || _a === void 0 ? void 0 : _a.replaceWith(newTimeSlotFieldset);
    }
    updateDurationChoices(documentFragment) {
        var _a;
        let newTimeSlotFieldset = documentFragment.getElementById("durationHoursFieldset");
        (_a = this.element.querySelector("#durationHoursFieldset")) === null || _a === void 0 ? void 0 : _a.replaceWith(newTimeSlotFieldset);
    }
    updateUserDetails(documentFragment) {
        var _a;
        let newUserDetailsFieldset = documentFragment.getElementById("userDetailsFieldset");
        (_a = this.element.querySelector("#userDetailsFieldset")) === null || _a === void 0 ? void 0 : _a.replaceWith(newUserDetailsFieldset);
    }
    updateFormActions(documentFragment) {
        var _a;
        let newFormActions = documentFragment.getElementById("formActions");
        (_a = this.element.querySelector("#formActions")) === null || _a === void 0 ? void 0 : _a.replaceWith(newFormActions);
    }
    _submitForm(event, refresh) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            (_a = document.getElementById("form-errors")) === null || _a === void 0 ? void 0 : _a.remove();
            let url = undefined;
            // Create an empty requestInit object
            let requestInit = {};
            requestInit.method = requestInit.method || "get";
            // If there's no optionsValue.body check if this element is a form and create FormData
            // Also set the Content-Type header if the form has one set
            if (this.element instanceof HTMLFormElement) {
                url = refresh ? new URL(window.location.href) : new URL(this.element.action);
                requestInit.method = refresh ? "get" : this.element.method;
                let formData = new FormData(this.element);
                let formUrlSearchParams = new URLSearchParams(this.formDataToStringPairs(formData));
                let formEncoding = this.element.encoding;
                switch (requestInit.method) {
                    case "post":
                        switch (formEncoding) {
                            case "multipart/form-data":
                                requestInit.body = formData;
                                break;
                            case "application/x-www-form-urlencoded":
                                requestInit.body = formUrlSearchParams;
                                break;
                        }
                        break;
                    case "get":
                        url.search = formUrlSearchParams.toString();
                        break;
                }
            }
            if (requestInit.body && !this.methodSupportsBody(requestInit.method)) {
                throw new Error(`${requestInit.method} does not support a "body"`);
            }
            this.element.classList.add("opacity-50");
            return fetch(url.toString(), requestInit)
                .then((response) => {
                // window.history.pushState(null, document.title, response.url);
                return response.text();
            })
                .then((html) => {
                return document.createRange().createContextualFragment(html);
            })
                .finally(() => {
                this.element.classList.remove("opacity-50");
            });
        });
    }
    methodSupportsBody(method) {
        return method == null || ["post", "patch", "put"].includes(method.toLowerCase());
    }
    /**
     * Convert FormData to string pairs
     * See: https://github.com/hotwired/turbo/commit/6b903e62de74e31047e5c296dbff68f812c6021e
     */
    formDataToStringPairs(formData) {
        let stringPairs = [];
        formData.forEach((value, key) => {
            if (typeof value == "string")
                stringPairs.push([key, value]);
        });
        return stringPairs;
    }
}
